module.exports = __webpack_public_path__ + "static/media/yuntaishan_plant.537e5bde.png";